import { Section } from '../components/Section';
import { Container } from '../components/Container';
import { FaqAccordion } from '../components/FaqAccordion';

const faqItems = [
  {
    question: 'Como funciona a cobrança?',
    answer:
      'O Mercado Pago cobra o cliente automaticamente na frequência escolhida. Quando o pagamento é aprovado, o Assine cria um pedido real na sua loja Nuvemshop. Você só precisa despachar.',
  },
  {
    question: 'Preciso ter conta no Mercado Pago?',
    answer:
      'Sim. O Assine usa o Mercado Pago para processar pagamentos recorrentes. Você conecta sua conta durante a configuração inicial.',
  },
  {
    question: 'O que acontece se o pagamento falhar?',
    answer:
      'O Assine inicia um processo de recuperação automático. O cliente recebe emails explicando o problema e o Mercado Pago tenta cobrar novamente. Se não recuperar em 7 dias, a assinatura é cancelada.',
  },
  {
    question: 'Meu cliente pode cancelar sozinho?',
    answer:
      'Sim. O portal do assinante permite que o cliente pause, pule uma entrega ou cancele a qualquer momento. Antes de cancelar, o Assine oferece alternativas como pausar ou pular a próxima entrega.',
  },
  {
    question: 'Funciona com qualquer tema da Nuvemshop?',
    answer:
      'Sim. O widget funciona tanto em temas Patagonia (novos) quanto em temas legados. Ele aparece automaticamente nas páginas de produtos com planos de assinatura.',
  },
  {
    question: 'Posso testar antes de pagar?',
    answer:
      'Sim. Instale o Assine e configure seu primeiro plano sem custo. O plano custa R$ 49/mês com tudo incluso.',
  },
];

export function Faq() {
  return (
    <Section background="white">
      <Container maxWidth="text">
        <h2
          style={{
            fontSize: '24px',
            fontWeight: 800,
            fontFamily: 'var(--font-heading)',
            color: '#111827',
            textAlign: 'center',
            marginBottom: 'var(--spacing-xl)',
            lineHeight: 1.2,
          }}
        >
          Perguntas frequentes
        </h2>
        <FaqAccordion items={faqItems} />
      </Container>
    </Section>
  );
}
